import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numeroConglomerado',
    standalone: false
})

export class NumeroConglomeradoPipe implements PipeTransform {

transform(value: string, args: any[]): string {
    return 'CGL' + `${value}`.padStart(3, '0');
   }
}
